module.exports = __webpack_public_path__ + "static/media/beer-bottle.ef329d08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/beer-bottle.svg
// module id = 150
// module chunks = 0